import { Component, Inject, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { PROJECT_DISPLAY_CONFIG } from 'src/app/config/project-display-config.token';
import { ProjectDisplayConfig } from 'src/app/config/config.model';
import { ProjectNotesStoreService } from 'src/app/project-display/data-access/project-notes-store-service';
import { IProjectNote } from 'src/app/project-display/interfaces/IProjectNote';




@Component({
  selector: 'eic-project-notes-container',
  templateUrl: './project-notes-container.html',
  styleUrl: './project-notes-container.scss'
})
export class ProjectNotesContainer implements OnInit {
  @Input() public projectId: number;
  @Input() public discriminator: string;

  projectNotes$: Observable<IProjectNote[]>;
  selectedNoteTypes: number[];
  noteCount: number;

  get isAsset(): boolean {
    return this.discriminator === 'Asset';
  }

  get showMemberNoteControls(): boolean {
    return !this.isAsset || this.projectDisplayConfig.enableMemberNotesForAssets;
  }




  constructor(
    public projectNotesStore: ProjectNotesStoreService,
    @Inject(PROJECT_DISPLAY_CONFIG) private projectDisplayConfig: ProjectDisplayConfig
  ) {

    projectNotesStore.noteCount$.subscribe((count:number) => {
      this.noteCount = count;
    });


    // this.projectNotes$ = of(this.sampleNotes);
  }
  ngOnInit(): void {
    // this.projectNotesStore.setProjectId(this.projectId);
    this.projectNotesStore.projectId = this.projectId;
  }



  selectedNoteTypes_change($event) {
    this.selectedNoteTypes = $event;
  }

  // Add some hard coded test data so the note format can
  // be developeded independently of data access
  sampleNotes = [
    {
      "projectNoteID": 289492,
      "projectID": 682631,
      "note": "Santee Cooper has filed a federal complaint in the US District Court for the District of South Carolina seeking formal declaration that it is the sole owner of equipment purchased for the abandoned project. The company has also asked a New York bankruptcy court to dismiss Westinghouse's claim of ownership of the same equipment. In addition, Santee Cooper has asked the court to require Westinghouse provide it with certification documentation related to the equipment.",
      "noteDate": "2019-05-16T00:00:00",
      "created": "2019-05-16T10:00:51.117",
      "createdBy": "Oliver Barnes",
      "updated": "2019-05-16T10:05:14.3",
      "updatedBy": "Oliver Barnes",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 253903,
      "projectID": 682631,
      "note": "The project's attempts to secure federal financing before eventually cancelling the project were not entertained. This potentially gives some indication on the new administrations stance on costly nuclear projects. ",
      "noteDate": "2017-08-07T00:00:00",
      "created": "2017-08-07T08:37:07.733",
      "createdBy": "Jake Gillan",
      "updated": "2017-08-07T08:39:21.173",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": true,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 5,
          "noteType": "General News"
        },
        {
          "noteTypeID": 7,
          "noteType": "Analyst Opinion"
        }
      ]
    },
    {
      "projectNoteID": 253903,
      "projectID": 682631,
      "note": "The project's attempts to secure federal financing before eventually cancelling the project were not entertained. This potentially gives some indication on the new administrations stance on costly nuclear projects. ",
      "noteDate": "2017-08-07T00:00:00",
      "created": "2017-08-07T08:37:07.733",
      "createdBy": "Jake Gillan",
      "updated": "2024-09-21T08:37:07.733",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": true,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 5,
          "noteType": "General News"
        },
        {
          "noteTypeID": 7,
          "noteType": "Analyst Opinion"
        }
      ]
    },
    {
      "projectNoteID": 253903,
      "projectID": 682631,
      "note": "The project's attempts to secure federal financing before eventually cancelling the project were not entertained. This potentially gives some indication on the new administrations stance on costly nuclear projects. ",
      "noteDate": "2017-08-07T00:00:00",
      "created": "2024-09-21T08:37:07.733",
      "createdBy": "Jake Gillan",
      "updated": "2024-09-21T08:37:07.733",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": true,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 5,
          "noteType": "General News"
        },
        {
          "noteTypeID": 7,
          "noteType": "Analyst Opinion"
        }
      ]
    },



    {
      "projectNoteID": 10105,
      "projectID": 682631,
      "note": "Jan. 11, 2017  RCH South Carolina Electric & Gas Company (SCE&G), principal subsidiary of SCANA Corporation (NYSE: SCG), and V.C. Summer Nuclear Station co-owner, Santee Cooper, placed on Jan. 10 the first steam generator at a Westinghouse AP1000 nuclear plant in the U.S. ",
      "noteDate": "2017-01-12T10:16:08.913",
      "created": "2017-01-12T10:16:08.913",
      "createdBy": "Robert Harrison",
      "updated": "2017-01-12T10:16:08.913",
      "updatedBy": "Robert Harrison",
      "isMemberNote": true,
      "isAnalystOpinion": false,
      "isNormalNote": false,
      "noteTypes": [
        {
          "noteTypeID": 6,
          "noteType": "Member Note"
        }
      ]
    },
    {
      "projectNoteID": 263036,
      "projectID": 682631,
      "note": "South Carolina Electric & Gas Company has filed a formal request with the Nuclear Regulatory Commission to withdraw the combined operating licenses for the two units. In the notification, the company states it has irrevocably abandoned its interest in the project. SCE&G has offered to cede its interest to Santee Cooper for no consideration.",
      "noteDate": "2017-12-28T00:00:00",
      "created": "2018-01-12T15:39:13.083",
      "createdBy": "Oliver Barnes",
      "updated": "2018-01-12T15:42:13.163",
      "updatedBy": "Oliver Barnes",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        },
        {
          "noteTypeID": 3,
          "noteType": "Planning Process"
        }
      ]
    },
    {
      "projectNoteID": 253597,
      "projectID": 682631,
      "note": "The boards of Santee Cooper (45%) and SCANA Corp. have voted to cease construction efforts at the site. Faced with a total project cost that has been projected to reach $25bn, the joint-operators plan to file permission with regulators to abandon project work. ",
      "noteDate": "2017-08-01T00:00:00",
      "created": "2017-08-01T08:37:04.407",
      "createdBy": "Jake Gillan",
      "updated": "2017-08-01T08:47:35.953",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    },
    {
      "projectNoteID": 253094,
      "projectID": 682631,
      "note": "A report has been commissioned by environmental groups that indicate completion of the plant could cost up to an additional US$10bn; which would not be in the best interest of consumers.  The report will be presented in support of the petition against further spending on the project. To date, approximately US$9bn has already been spent or committed. ",
      "noteDate": "2017-07-19T00:00:00",
      "created": "2017-07-20T10:05:54.49",
      "createdBy": "Monique Aceves",
      "updated": "2017-07-20T10:15:57.863",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 4,
          "noteType": "Financial News"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 251520,
      "projectID": 682631,
      "note": "The deadline for nuclear energy tax credits has been extended to 2020 by the House Ways and Means Committee. Currently the future of both the VC Summer, and the Vogtle facilities are hanging in the balance, so the extension, which applies to projects that are due to be complete before 2021, could prove crucial to the ongoing negotiations with Westinghouse and ultimately whether or not the two facilities will ever be completed.  ",
      "noteDate": "2017-06-20T00:00:00",
      "created": "2017-06-20T15:34:29.827",
      "createdBy": "Jake Gillan",
      "updated": "2017-06-20T15:40:18.107",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 4,
          "noteType": "Financial News"
        }
      ]
    },
    {
      "projectNoteID": 250092,
      "projectID": 682631,
      "note": "Industry analysts are suggesting that Westinghouse is expected to break contractual agreements to design and build the facility after reaching agreements on both the Vogtle and V.C. Summer related to liability payment schedules. ",
      "noteDate": "2017-05-25T00:00:00",
      "created": "2017-05-25T08:18:28.483",
      "createdBy": "Jake Gillan",
      "updated": "2017-05-25T11:36:12.38",
      "updatedBy": "Pietro Ferreira",
      "isMemberNote": false,
      "isAnalystOpinion": true,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        },
        {
          "noteTypeID": 7,
          "noteType": "Analyst Opinion"
        }
      ]
    },



  ]





  testData = [
    {
      "projectNoteID": 289492,
      "projectID": 682631,
      "note": "Santee Cooper has filed a federal complaint in the US District Court for the District of South Carolina seeking formal declaration that it is the sole owner of equipment purchased for the abandoned project. The company has also asked a New York bankruptcy court to dismiss Westinghouse's claim of ownership of the same equipment. In addition, Santee Cooper has asked the court to require Westinghouse provide it with certification documentation related to the equipment.",
      "noteDate": "2019-05-16T00:00:00",
      "created": "2019-05-16T10:00:51.117",
      "createdBy": "Oliver Barnes",
      "updated": "2019-05-16T10:05:14.3",
      "updatedBy": "Oliver Barnes",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 282377,
      "projectID": 682631,
      "note": "Santee Cooper has filed a lawsuit against South Carolina Electric & Gas accusing it of fraud and misconduct that caused billions of dollars to be wasted on the project.",
      "noteDate": "2019-01-02T00:00:00",
      "created": "2019-01-15T11:21:07.017",
      "createdBy": "Oliver Barnes",
      "updated": "2019-01-15T11:21:58.233",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 263036,
      "projectID": 682631,
      "note": "South Carolina Electric & Gas Company has filed a formal request with the Nuclear Regulatory Commission to withdraw the combined operating licenses for the two units. In the notification, the company states it has irrevocably abandoned its interest in the project. SCE&G has offered to cede its interest to Santee Cooper for no consideration.",
      "noteDate": "2017-12-28T00:00:00",
      "created": "2018-01-12T15:39:13.083",
      "createdBy": "Oliver Barnes",
      "updated": "2018-01-12T15:42:13.163",
      "updatedBy": "Oliver Barnes",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        },
        {
          "noteTypeID": 3,
          "noteType": "Planning Process"
        }
      ]
    },
    {
      "projectNoteID": 254167,
      "projectID": 682631,
      "note": "Industry intelligence indicates that Santee Cooper, one of the projects' co-operators, is looking to sell it's stake in the ill-fated development. This could mean that plans to scrap the project completely could change. ",
      "noteDate": "2017-08-10T00:00:00",
      "created": "2017-08-10T14:18:23.717",
      "createdBy": "Jake Gillan",
      "updated": "2017-08-10T14:20:01.887",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 3,
          "noteType": "Planning Process"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 253903,
      "projectID": 682631,
      "note": "The project's attempts to secure federal financing before eventually cancelling the project were not entertained. This potentially gives some indication on the new administrations stance on costly nuclear projects. ",
      "noteDate": "2017-08-07T00:00:00",
      "created": "2017-08-07T08:37:07.733",
      "createdBy": "Jake Gillan",
      "updated": "2017-08-07T08:39:21.173",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": true,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 5,
          "noteType": "General News"
        },
        {
          "noteTypeID": 7,
          "noteType": "Analyst Opinion"
        }
      ]
    },
    {
      "projectNoteID": 253597,
      "projectID": 682631,
      "note": "The boards of Santee Cooper (45%) and SCANA Corp. have voted to cease construction efforts at the site. Faced with a total project cost that has been projected to reach $25bn, the joint-operators plan to file permission with regulators to abandon project work. ",
      "noteDate": "2017-08-01T00:00:00",
      "created": "2017-08-01T08:37:04.407",
      "createdBy": "Jake Gillan",
      "updated": "2017-08-01T08:47:35.953",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    },
    {
      "projectNoteID": 253598,
      "projectID": 682631,
      "note": "Toshiba has agreed to pay close to $2.2bn to cover further construction costs at the construction site. The multi-billion dollar deal does not however guarantee completion of the facility as it is estimated that the project will require an investment of around $10bn in order for it to be completed. ",
      "noteDate": "2017-07-31T00:00:00",
      "created": "2017-07-31T12:40:55.197",
      "createdBy": "Jake Gillan",
      "updated": "2017-07-31T12:53:26.38",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    },
    {
      "projectNoteID": 253454,
      "projectID": 682631,
      "note": "Subject to court approval, the agreement between Scana Corporation and Westinghouse that allows continued work on the two new AP1000 units has been extended to 10 August. The extension allows for a \"transition and evaluation period\" during which work is permitted to continue while an assessment can be made to determine the best course of action during Westinghouse's bankruptcy proceedings.",
      "noteDate": "2017-07-27T00:00:00",
      "created": "2017-07-27T16:31:03.317",
      "createdBy": "Monique Aceves",
      "updated": "2017-07-27T16:39:23.647",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        },
        {
          "noteTypeID": 3,
          "noteType": "Planning Process"
        }
      ]
    },
    {
      "projectNoteID": 253094,
      "projectID": 682631,
      "note": "A report has been commissioned by environmental groups that indicate completion of the plant could cost up to an additional US$10bn; which would not be in the best interest of consumers.  The report will be presented in support of the petition against further spending on the project. To date, approximately US$9bn has already been spent or committed. ",
      "noteDate": "2017-07-19T00:00:00",
      "created": "2017-07-20T10:05:54.49",
      "createdBy": "Monique Aceves",
      "updated": "2017-07-20T10:15:57.863",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 4,
          "noteType": "Financial News"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 251964,
      "projectID": 682631,
      "note": "More bad news for Westinghouse as their case against Chicago Bridge and Iron (CB&I) has been overturned. It had previously been ruled that Westinghouse were entitled to claim up to $2.15bn back from CB&I following their acquisition of Stone and Webster in 2015. Westinghouse purchased Stone and Webster and then worked with them begin the construction of major nuclear projects. Westinghouse claimed that CB&I submitted misleading financial statements during the sale of Stone and Webster  which have amplified the cost overruns on the V.C. Summer and Vogtle nuclear projects. However, a judge in the Delaware Supreme Court ruled that Westinghouse \"was seeking to maintain the upside of the deal, while sticking CB&I with spiralling costs.\" With the ruling, Westinghouse's financial health has been further damaged. It is unclear what effect this will have on the nuclear projects being constructed in Georgia and South Carolina. ",
      "noteDate": "2017-06-29T00:00:00",
      "created": "2017-06-29T08:23:54.23",
      "createdBy": "Jake Gillan",
      "updated": "2017-06-29T12:15:29.107",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 4,
          "noteType": "Financial News"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 251830,
      "projectID": 682631,
      "note": "South Carolina Gas and Electric (SCG&E) has reached an interim agreement with Westinghouse for construction to continue into August. The agreement will give SCG&E enough time to come to a decision on whether or not they will take the project forward to completion. ",
      "noteDate": "2017-06-27T00:00:00",
      "created": "2017-06-27T08:18:42.697",
      "createdBy": "Jake Gillan",
      "updated": "2017-06-27T08:22:08.677",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    },
    {
      "projectNoteID": 251784,
      "projectID": 682631,
      "note": "The construction at V.C. Summer is now under threat from a coalition of groups (Friends of the Earth, and the Sierra Club) who have filed a petition in protest of the planned nuclear facility. The protest aims to halt further spending on the project so as not to incur \"massive rate spikes for consumers\" once the plant comes online. ",
      "noteDate": "2017-06-26T00:00:00",
      "created": "2017-06-26T08:59:42.347",
      "createdBy": "Jake Gillan",
      "updated": "2017-06-26T10:00:19.473",
      "updatedBy": "Neil Golding",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    },
    {
      "projectNoteID": 251520,
      "projectID": 682631,
      "note": "The deadline for nuclear energy tax credits has been extended to 2020 by the House Ways and Means Committee. Currently the future of both the VC Summer, and the Vogtle facilities are hanging in the balance, so the extension, which applies to projects that are due to be complete before 2021, could prove crucial to the ongoing negotiations with Westinghouse and ultimately whether or not the two facilities will ever be completed.  ",
      "noteDate": "2017-06-20T00:00:00",
      "created": "2017-06-20T15:34:29.827",
      "createdBy": "Jake Gillan",
      "updated": "2017-06-20T15:40:18.107",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 4,
          "noteType": "Financial News"
        }
      ]
    },
    {
      "projectNoteID": 250853,
      "projectID": 682631,
      "note": "Talk surrounding the future of the project is ongoing following Westinghouse's bankruptcy. Summer has an interim construction agreement with Westinghouse that lasts until the 26th of June, 2017. ",
      "noteDate": "2017-06-09T00:00:00",
      "created": "2017-06-09T08:38:11.127",
      "createdBy": "Jake Gillan",
      "updated": "2017-06-09T08:39:57.8",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    },
    {
      "projectNoteID": 250092,
      "projectID": 682631,
      "note": "Industry analysts are suggesting that Westinghouse is expected to break contractual agreements to design and build the facility after reaching agreements on both the Vogtle and V.C. Summer related to liability payment schedules. ",
      "noteDate": "2017-05-25T00:00:00",
      "created": "2017-05-25T08:18:28.483",
      "createdBy": "Jake Gillan",
      "updated": "2017-05-25T11:36:12.38",
      "updatedBy": "Pietro Ferreira",
      "isMemberNote": false,
      "isAnalystOpinion": true,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        },
        {
          "noteTypeID": 7,
          "noteType": "Analyst Opinion"
        }
      ]
    },
    {
      "projectNoteID": 249337,
      "projectID": 682631,
      "note": "The project is now over 64% complete. As of 31 March 2017, the project's engineering phase was 96.0% complete, with procurement 88.2% complete, construction 34.3% complete and start-up activities 8.6% complete. A decision by SCE&G on whether to cancel or defer either of the units is expected to be made during the second quarter of 2017 following Westinghouse's bankruptcy filing on 29 March 2017.",
      "noteDate": "2017-05-09T00:00:00",
      "created": "2017-05-09T10:52:20.9",
      "createdBy": "Oliver Barnes",
      "updated": "2017-05-09T10:57:22.967",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    },
    {
      "projectNoteID": 247939,
      "projectID": 682631,
      "note": "Westinghouse filed for Chapter 11 on 29 March 2017; SCANA Corporation is now considering whether to abandon one or both units.  SCANA Corporation and Santee Cooper have negotiated an agreement with Westinghouse to continue construction for a 30-day evaluation period.  The agreement is subject to bankruptcy court approval. ",
      "noteDate": "2017-03-30T00:00:00",
      "created": "2017-03-30T16:19:30.707",
      "createdBy": "Monique Aceves",
      "updated": "2017-03-30T16:48:04.797",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 4,
          "noteType": "Financial News"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 246470,
      "projectID": 682631,
      "note": "Westinghouse and Toshiba have said they are committed to completing the project, despite Toshiba announcing it would reduce its exposure to reactor construction outside Japan. The units are now due to be completed in April 2020 and December 2020 for units 2 and 3 respectively.",
      "noteDate": "2017-02-15T00:00:00",
      "created": "2017-02-16T09:17:36.39",
      "createdBy": "Oliver Barnes",
      "updated": "2017-02-16T09:20:10.227",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        },
        {
          "noteTypeID": 5,
          "noteType": "General News"
        }
      ]
    },
    {
      "projectNoteID": 10105,
      "projectID": 682631,
      "note": "Jan. 11, 2017  RCH South Carolina Electric & Gas Company (SCE&G), principal subsidiary of SCANA Corporation (NYSE: SCG), and V.C. Summer Nuclear Station co-owner, Santee Cooper, placed on Jan. 10 the first steam generator at a Westinghouse AP1000 nuclear plant in the U.S. ",
      "noteDate": "2017-01-12T10:16:08.913",
      "created": "2017-01-12T10:16:08.913",
      "createdBy": "Robert Harrison",
      "updated": "2017-01-12T10:16:08.913",
      "updatedBy": "Robert Harrison",
      "isMemberNote": true,
      "isAnalystOpinion": false,
      "isNormalNote": false,
      "noteTypes": [
        {
          "noteTypeID": 6,
          "noteType": "Member Note"
        }
      ]
    },
    {
      "projectNoteID": 245264,
      "projectID": 682631,
      "note": "The first of two steam generators was lifted into place at unit 2 on 10 January 2017.",
      "noteDate": "2017-01-12T00:00:00",
      "created": "2017-01-12T11:06:16.74",
      "createdBy": "Oliver Barnes",
      "updated": "2017-01-12T11:09:04.547",
      "updatedBy": "Amisha Patel",
      "isMemberNote": false,
      "isAnalystOpinion": false,
      "isNormalNote": true,
      "noteTypes": [
        {
          "noteTypeID": 2,
          "noteType": "Development News"
        }
      ]
    }
  ]


}
